import { render, staticRenderFns } from "./Delegate.vue?vue&type=template&id=1ab228fb"
import script from "./Delegate.vue?vue&type=script&lang=js"
export * from "./Delegate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports